module.exports = __webpack_public_path__ + "static/media/FREERIDER-RF-42-iQ.25e39c7d.png";